import { useOrg } from '@/features/team/OrgProvider';
import { EncabezadoPantalla } from '@/ui/Sistema';
import { SelectorPeriodo } from '@/features/period/SelectorPeriodo';
import { PricesCard } from './PricesCard';

/**
 * Precios de referencia, con pantalla propia.
 *
 * Sin el precio del novillo no hay honorarios y sin el del combustible no hay
 * movilidad: es lo primero que hay que cargar cada mes. Tenerlo a un toque
 * evita el arranque en falso de cargar trabajos que quedan todos pendientes.
 */
export function PreciosPage({ onVolver }: { onVolver: () => void }) {
  const { activeOrg } = useOrg();
  const orgId = activeOrg?.organization_id;
  if (!orgId) return null;

  const isAdmin = activeOrg.is_admin ?? false;

  return (
    <div className="flex flex-col gap-6 p-4" data-testid="precios-page">
      <EncabezadoPantalla
        titulo="Precios"
        nota="Novillo y combustible del mes"
        onVolver={onVolver}
      />
      <SelectorPeriodo testId="precios-periodo" />
      <PricesCard organizationId={orgId} isAdmin={isAdmin} kind="steer" />
      <PricesCard organizationId={orgId} isAdmin={isAdmin} kind="fuel" />
    </div>
  );
}
